// Module
var code = "<span ng-if=\"isClosed()\">{{selectedValue[0].name}}</span> <select ng-if=\"!isClosed()\" ng-focus=\"setClosed(false)\" ng-blur=\"setClosed(true)\" ng-model=\"userTypeId\" ng-change=\"changeUserType(userTypeId)\" ng-options=\"userType.id as userType.name for userType in userTypes\"></select>";
// Exports
module.exports = code;